import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AgentService, AgentServicesClient, BankDetails, BankDetailsClient, DeliverService, DeliverServicesClient, Kasa, KasaClient, ServiceRequest, TaxesSettlementsDetails, TaxSettlementClient } from "src/app/web-api-client";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { forkJoin, Subject } from "rxjs";
import { WtStorageService } from "../../wt-storage.service";
import { BankAccountAddComponent } from "../../components/bank-account/bank-account-add/bank-account-add.component";

@Component({
  selector: 'app-bank-selector',
  templateUrl: './bank-selector.component.html',
  styleUrls: ['./bank-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankSelectorComponent implements OnInit {

  @Input()  selectedBankDetails?: BankDetails;
  @Output() selectedAccount: Subject<BankDetails> = new Subject();

  public isLoaded = false;
  public bankAccounts: BankDetails[];
  public selectedBankAccount: number;

  public onClose: Subject<void> = new Subject();




  Form: FormGroup;

  constructor(private fb: FormBuilder, private readonly modalService: NgbModal,public _cdr: ChangeDetectorRef, public activeModal: NgbActiveModal,  public wtStore: WtStorageService, public client: BankDetailsClient) { }

  ngOnInit() {

    this.loadData();

  }

  private loadData() {
    this.isLoaded = false;

    this.client.getList().subscribe(b => {

      this.bankAccounts = b;

      if(this.selectedBankDetails){
        this.selectedBankAccount = this.selectedBankDetails.idBankDetails;
      }
      this.isLoaded = true;

      this._cdr.detectChanges();
    })
  }

  public onBankAccountChange(bankDetails: any) {
    const account = this.bankAccounts.find(d => d.idBankDetails == this.selectedBankAccount);
    this.selectedAccount.next(account);
    this._cdr.detectChanges();
  }


  public createBankAccount() {
    const modalRef = this.modalService.open(BankAccountAddComponent, { size: 'xl', centered: true, backdrop: 'static' });

    modalRef.componentInstance.onClose.subscribe(r => {

      this.loadData();
    });

    modalRef.result.then((result) => {
      // Handle the result from the modal
    }, (reason) => {
      // Handle the dismissal of the modal
    });
  }

}


